import './style/service-info.css';
import { useRef, useEffect } from 'react';
import { connect } from 'react-redux'
const ServiceInfoBox = (props) => {
    // if searched then click on service Box item to open servicelist
    const { searchParam } = props
    const itemRef = useRef()
    useEffect(() => {
        if (searchParam){
            itemRef.current.click()
        }
    }, [searchParam])
    const renderContent = props.content.map((x, i) => {
        return (
                <div className="service-content-item" key={i} onClick={() => props.onClick()} ref={itemRef}>
                    <p>{x}</p>
                    <i className="angle right icon"></i>
                </div>
                )      

    })
    return (
        <div className={`main-container ${props.mobileNav ? "ui container" : null}`}>
            <div className="service-info-box">
                <div className="service-info__title"><h1>{props.title}:</h1></div>
                <div className="service-info-content">
                    {renderContent}
                </div>
            </div>
            <div className="service-info-rating">
                    <div className="star-rating">
                        <div className="header"><i className="star icon" />{props.rating}/5</div>
                        <span className="rating-content">based on {props.ratingCount}<br /> ratings</span>
                    </div>
                    <div className="booking-done">
                        <div className="header">{props.bookingDone}</div>
                        <span className="booking-text">Bookings done in last <br />1 year</span>
                    </div>
            </div>
        </div>

    )
}
const mapStateToProps = (state) => {
    return {
        mobileNav: state.mobileNav
    }
}
export default connect(mapStateToProps)(ServiceInfoBox)
// <i class="angle right icon"></i>